function getHeaderLabel(header) {
    return header.textContent.replace(/\s+/g, " ").trim();
}

function responsiveTables() {
    document.querySelectorAll(".bn-table table, .wp-block-table table").forEach((table) => {
        const headers = Array.from(table.querySelectorAll("thead tr:first-child > th, thead tr:first-child > td"));

        if (!headers.length) {
            return;
        }

        table.classList.add("bn-responsive-table");

        table.querySelectorAll("tbody tr").forEach((row) => {
            Array.from(row.children).forEach((cell, index) => {
                const header = headers[index];

                if (header && (cell.matches("th") || cell.matches("td"))) {
                    cell.dataset.label = getHeaderLabel(header);
                }
            });
        });
    });
}

module.exports = { responsiveTables };